<template>
  <div class="classroom">
    <div class = "header">
      <div class = "info">
        <h1>{{classroom.name}} <span class = "institution">{{classroom.institution.name}}</span></h1>
        <!-- <h2>{{classroom.description}}</h2> -->
      </div>
      <div class = "class-code">
        <p class = "code"> {{classroom.enterCode}} </p>
      </div>
    </div>

    <div class = "students-info">
      <div class = "students">
        <h3>Alumnos ({{classroom.members.length}}) </h3>
        <ul>
          <li v-for="student in classroom.members" v-on:click = "classProjectsByOwner(classroom.id, student.id)" :key="student.id" class="student" :class = "{ active: userSelected === student.id }">
            <user-icon :picture = "student.picture"></user-icon>
            <span v-if="student.name"> {{student.name}} </span>
            <span v-else> Anónimo </span>
          </li>
        </ul>
      </div>
      <div class = "projects">
        <h3>Proyectos</h3>
        <ul>
          <li v-for = "p in userProjects" :key = "p.id">
            <span>{{p.name}}</span>
            <router-link :to="{ name: 'Editor.load', params: {projectId: p.id} }" target="_blank">Ver</router-link></li>
        </ul>
      </div>
    </div>
    <!--
    <router-link :to="{ name: 'classroom', params: { otherClases: myUserInfo.owns_classrooms, classid: clase.id + '' }}" class="button"  >ir</router-link>
    -->
  </div>
</template>

<script>
import UserIcon from './UserIcon'

export default {
  name: 'ClassroomDetail',
  components: {
    UserIcon
  },
  props: {
    classroom: Object
  },
  data: () => ({
    userSelected: null,
    userProjects: []
  }),
  computed: {
  },
  methods: {
    classProjectsByOwner (classId, userId) {
      console.log('classId', classId, userId)
      this.userSelected = userId
      this.userProjects = this._.groupBy(this.$store.state.user.teacher_ClassSharedProjects[classId], 'owner.id')[userId]
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) "../../assets/styles/main.less";

.classroom {
  overflow: hidden;
  position: relative;
  margin-bottom: 35px;
  box-shadow: 0px 0px 1px 1px #0002;
  background: @lightGray;

  & > div {
    padding: 12px;
  }

  .header {
    display: flex;
    justify-content: space-between;

    .institution {
      color: #8c8c8c;
    }
  }
}

.students-info {
  display: flex;

  & > div {
    padding: 12px;
  }

  h3 {
    margin-bottom: 12px;
  }

  .students {
    flex: 1;

    ul {
      // overflow-y: scroll;
    }

    .student {
      background: transparent;
      border-radius: 25px;
      padding: 5px 12px 5px 7px;
      margin: 0px 5px 5px 0px;
      display: inline-flex;
      justify-items: center;
      align-items: center;
      cursor: pointer;

      &.active {
        background: #00000038;
      }

      .userinfo {
        display: flex;
      }

      span {
        margin-left: 5px;
      }
    }
  }

  .projects {
    flex: 1;
  }
}

.class-code {
  border-bottom: 2px dotted #585870;

  .code {
    .font-code;
    padding: 2px 5px;
    font-weight: 800;
    color: #585858;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/ClassroomDetail.vue